import { MdClose } from 'react-icons/md';
import React from 'react';
import { CloseButtonProps } from 'react-toastify';
import { ToastProps } from './types';

export const CloseToastIcon = ({
  defaultProps,
  closeButtonProps,
}: {
  defaultProps: ToastProps;
  closeButtonProps: CloseButtonProps;
}) => {
  const { button, additionalInfo } = defaultProps ?? {};

  const alignItems = button || additionalInfo ? 'flex-start' : 'center';
  const padding = button || additionalInfo ? '4px' : '0';

  return (
    <div
      onClick={closeButtonProps.closeToast}
      style={{ display: 'flex', alignItems: alignItems, padding: padding }}
    >
      <MdClose size={24} color='rgba(146, 151, 162, 1)' />
    </div>
  );
};
